import { Checkbox, styled } from '@mui/material'

const SelectionCheckbox = styled(Checkbox)(({ theme }) => ({
  fontSize: '1.5rem',
  position: 'relative',

  '&.MuiCheckbox-sizeSmall': {
    fontSize: '1.25rem',
  },

  '&.Mui-checked::before': {
    backgroundColor: theme.palette.common.white,
    borderRadius: 2,
    content: '""',
    height: '0.6em',
    left: '50%',
    pointerEvents: 'none',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '0.6em',
  },

  '& .MuiSvgIcon-root': {
    fontSize: '1em',
    position: 'relative',
    zIndex: 1,
  },
}))

export default SelectionCheckbox
